import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import "../ModalAdmin.scss"
import { VistaEmpresasContext } from '../../../Admin/consultora/VistaEmpresasAdmin'
import { listaAreasConsulContext } from '../../../Admin/consultora/ListaAreasConsul'
import { useAdmin } from '../../../../context/AdminContext'
import { AreaContext } from '../../../../context/AreaContext'

function ModalAreaConsul(props) {
    
    const { user, idEmpresa } = useContext(VistaEmpresasContext)
    const { setAreas } = useContext(AreaContext)
    const { idArea, setIdArea, objArea, setObjArea } = useContext(listaAreasConsulContext)

    const { fetchArea, setErrorArea } = useAdmin()

    const [newArea, setNewArea] = useState({
        nombre: "",
        powerBi: ""
    })

    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    useEffect(()=>{
        if(objArea){
            const obj = JSON.parse(objArea)
            setNewArea({
                nombre: obj.nombre_del_Area,
                powerBi: obj.powerBi === null ? "" : obj.powerBi
            })
        }

    },[objArea])

    const handleClose = () => {
        setErrors({})
        setNewArea({
            nombre: "",
            powerBi: ""
        })
        setObjArea(null)
        setIdArea(null)
        setModalErr(null)
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewArea({
          ...newArea,
          [name]: value,
        })
    }

    const validateForm = (data) => {
        const errors = {}
        if(!data.nombre.trim()) {
            errors.nombre = "Escriba el nombre del empleado."
        }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newArea)
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            const obj = {
                user,
                idEmpresa,
                nombre: newArea.nombre,
                power_Bi: newArea.powerBi === "" ? null : newArea.powerBi
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/organitation/addAreas`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0){
                    setModalErr(data.errorDetalle || data.codeError)
                } else {
                    props.onHide()
                    setErrors({})
                    setNewArea({
                        nombre: "",
                        powerBi: ""
                    })
                    setModalErr(null)
                    // actualizar áreas
                    fetchArea(user, idEmpresa)
                    .then(res => {
                        if(res.status !== 0){
                            setErrorArea(res.codeError)
                        } else {
                            setAreas(res.objeto)
                        }
                    })
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    const handleChangeArea = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newArea)
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            const obj = {
                user,
                idArea,
                nombre: newArea.nombre,
                power_Bi: newArea.powerBi === "" ? null : newArea.powerBi
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/organitation/editAreas`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                if(data.error !== 0){
                    setModalErr(data.codeError)
                } else {
                    props.onHide()
                    setErrors({})
                    setNewArea({
                        nombre: "",
                        powerBi: ""
                    })
                    setModalErr(null)
                    setObjArea(null)
                    setIdArea(null)
                    // actualizar áreas
                    fetchArea(user, idEmpresa)
                    .then(res => {
                        if(res.status !== 0){
                            setErrorArea(res.codeError)
                        } else {
                            setAreas(res.objeto)
                        }
                    })
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    return (
        <Modal
            {...props}
            // size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__area'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    {objArea ? <h3 className='m-0'>Modificar área</h3>: <h3 className='m-0'>Agregar área</h3>}
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {objArea ? (
                    <form className='form__area d-flex flex-column' onSubmit={handleChangeArea}>
                        <div className='mb-2'>
                            <label className='mb-1'>Nombre*</label>
                            <input
                                onChange={handleChange}
                                type="text" 
                                id="nombre" 
                                name="nombre" 
                                autoFocus
                                className="form-control form-control-sm col-12"
                                value={newArea.nombre}
                            />
                            {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                        </div>
                        <div className='mb-2'>
                            <label className='mb-1'>Link de tablero Power Bi (opcional)</label>
                            <input
                                onChange={handleChange}
                                type="text" 
                                id="powerBi" 
                                name="powerBi" 
                                className="form-control form-control-sm col-12"
                                value={newArea.powerBi}
                            />
                            <p className='m-0 p-0'><span className='form__example'>*Ejemplo: https://app.powerbi.com/view?r=eyJrIjoiOWY3YWE4NT...</span></p>
                            {errors.powerBi && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.powerBi}</span>}
                        </div>
                        {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                        <button 
                            type='submit' 
                            className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                        >
                            Modificar área
                        </button>
                    </form>
                ) : (
                    <form className='form__area d-flex flex-column' onSubmit={handleSubmit}>
                        <div className='mb-2'>
                            <label className='mb-1'>Nombre*</label>
                            <input
                                onChange={handleChange}
                                type="text" 
                                id="nombre" 
                                name="nombre" 
                                autoFocus
                                className="form-control form-control-sm col-12"
                                value={newArea.nombre}
                            />
                            {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                        </div>
                        <div className='mb-2'>
                            <label className='mb-1'>Link de tablero Power Bi (opcional)</label>
                            <input
                                onChange={handleChange}
                                type="text" 
                                id="powerBi" 
                                name="powerBi" 
                                className="form-control form-control-sm col-12"
                                value={newArea.powerBi}
                            />
                            <p className='m-0 p-0'><span className='form__example'>*Ejemplo: https://app.powerbi.com/view?r=eyJrIjoiOWY3YWE4NT...</span></p>
                            {errors.powerBi && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.powerBi}</span>}
                        </div>
                        {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                        <button 
                            type='submit' 
                            className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                        >
                            Agregar área
                        </button>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    )

}

export default ModalAreaConsul
